import { useMemo, useState } from 'react'
import type { ManufacturerRow, ManufacturerFilters } from './ManufacturerList.types'

export function useManufacturerFilters(rows: ManufacturerRow[]) {
  const [filters, setFilters] = useState<ManufacturerFilters>({
    manufacturer: '',
    alias: '',
    oemCode: '',
    url: '',
    direct: false,
  })

  const filteredRows = useMemo(() => {
    const manufacturer = filters.manufacturer.trim()
    const alias = filters.alias.trim().toLowerCase()
    const oemCode = filters.oemCode.trim().toLowerCase()
    const url = filters.url.trim().toLowerCase()

    return rows.filter(r => {
      const matchesManufacturer = !manufacturer || r.provider === manufacturer

      const matchesAlias = !alias || r.aliases.some((a: string) => a.toLowerCase().includes(alias))

      const matchesOem = !oemCode || (r.mfrCodeUpper ?? '').toLowerCase().includes(oemCode)

      const matchesUrl = !url || (r.url ?? '').toLowerCase().includes(url)

      const matchesDirect = !filters.direct

      return matchesManufacturer && matchesAlias && matchesOem && matchesUrl && matchesDirect
    })
  }, [rows, filters])

  const manufacturerOptions = useMemo(() => {
    return Array.from(new Set(rows.map(r => r.provider))).sort()
  }, [rows])

  return {
    filters,
    setFilters,
    filteredRows,
    manufacturerOptions,
  }
}
